<template>
  <div
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="main">
      <!-- 顶部广告条 -->
      <!-- <div class="topBanner">
        <img src="" alt />
        <span>广告</span>
      </div> -->
      <Topadv v-if="keywords" :keys="keywords" :advId="647"></Topadv>

      <div class="breadcrumb">
        <span
          class="crumb"
          @click="
            $router.push({ path: '/' });
            resetSetItem('isActive', 0);
          "
          >首页</span
        >
        <span>></span>
        <span
          v-if="!isSearch"
          class="crumb"
          @click="$router.push({ path: '/radio' })"
          >音频</span
        >
        <span v-if="!isSearch">></span>
        <span
          v-if="!isSearch"
          class="crumb"
          @click="
            $router.push({
              name: 'radio_detail',
              params: { id: PId, title: pTitle }
            })
          "
          >{{ programTitle }}</span
        >
        <span
          v-if="isSearch"
          class="crumb"
          @click="
            $router.push({ name: 'search', params: { keyword: keyword } })
          "
          >搜索</span
        >
        <span>></span>
        <span style="color:#0091ff">{{ title }}</span>
      </div>
      <div class="main-content">
        <div class="content-l">
          <div class="box">
            <div class="article-detail">
              <div class="left">
                <div class="img">
                  <img :src="infoList.cover_url" class="articleImg" alt />
                  <img src="@/assets/img/radio1.png" alt />
                </div>
                <div class="info">
                  <div class="name">{{ infoList.title }}</div>
                  <div class="data">
                    <div>
                      <div class="paly">
                        <span>播放：</span>
                        {{ infoList.visit_times }}次
                      </div>
                      <div class="update">
                        <span>最新更新：</span>
                        {{ infoList.display_time | timefilters }}
                      </div>
                    </div>
                    <div class="laberList">
                      <div
                        v-for="(item, i) in infoList.really_tags"
                        :key="i"
                        @click="aboutLaber(item)"
                        class="laber"
                      >
                        #{{ item }}
                      </div>
                    </div>
                  </div>
                  <div class="from">
                    <span>来源于：</span>
                    <div
                      @click="goAudio(infoList.audio_id)"
                      style="cursor: pointer;display: inline-block;"
                    >
                      {{ infoList.audio_title }}
                    </div>
                  </div>
                  <div
                    style="display:flex;justify-content: space-between;align-items: center;"
                  >
                    <div>
                      <div class="btn" v-if="!infoList.is_jurisdiction">
                        <el-button @click="audition">
                          <img src="@/assets/img/icon_paly.png" alt />
                          试听
                        </el-button>
                        <el-button @click="memberBtn">听完整版</el-button>
                      </div>
                      <div class="btn" v-else>
                        <el-button
                          @click="audition"
                          style="background: #fff;color: #0091ff;border:1px solid"
                        >
                          <img src="@/assets/img/icon_paly.png" alt />
                          <span style="vertical-align: middle;">播放</span>
                        </el-button>
                      </div>
                    </div>
                    <div class="nums">
                      <div>
                        <img
                          src="@/assets/img/like2.png"
                          alt
                          v-if="infoList.is_like"
                          @click="praiseBtn"
                        />
                        <img
                          src="@/assets/img/like1.png"
                          alt
                          v-else
                          @click="praiseBtn"
                        />
                        <span>{{ infoList.like_times }}人点赞</span>
                      </div>
                      <div>
                        <img
                          src="@/assets/img/collection1.png"
                          alt
                          v-if="infoList.is_favorited"
                          @click="collectionBtn"
                        />
                        <img
                          src="@/assets/img/collection.png"
                          alt
                          v-else
                          @click="collectionBtn"
                        />
                        <span>{{ infoList.favorite_times }}人收藏</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="progranmText">
              <p class="title">
                <span>节目正文</span>
              </p>
              <div
                v-html="infoList.content"
                :class="{ showall: true, active: showall }"
              >
                {{ infoList.content }}
              </div>
              <div class="cont-mask" v-if="!showall">
                <img src="@/assets/img/cont_mask.png" alt />
              </div>

              <div
                class="mui-text-center imgbtn"
                :class="{ active: showall }"
                @click="all"
                v-if="!showall"
              >
                查看全部
                <img src="@/assets/img/down_arrow.png" alt />
              </div>

              <p v-if="showall" class="copyright">
                <span>本文版权归第一财经杂志所有</span>
                <br />
                <span>未经许可不得转载或翻译</span>
              </p>
            </div>

            <DetailPagation :info="infoList" />

            <div class="comment">
              <p class="title">评论</p>
              <div class="comment-box">
                <div class="img">
                  <img src="@/assets/img/avatar.png" alt v-if="showAvatar" />
                  <img :src="avatar" alt v-else />
                  <!-- 用户头像 -->
                </div>
                <div class="commentInput">
                  <el-input
                    type="textarea"
                    :rows="5"
                    v-model="commentCont"
                    maxlength="200"
                    show-word-limit
                  ></el-input>
                  <div>
                    <el-button @click="publishBtn">发表</el-button>
                  </div>
                </div>
              </div>
              <div>
                <ul class="evaluate">
                  <li v-for="(item, i) in evaluateList" :key="i">
                    <div class="img">
                      <img :src="item.user.avatar" alt />
                    </div>
                    <div class="cont">
                      <p class="name">{{ item.user.nickname }}</p>
                      <p class="time">{{ item.display_time | timefilters }}</p>
                      <div>{{ item.content }}</div>
                    </div>
                    <div class="like">
                      <span>{{ item.like_times }}</span>
                      <img
                        src="@/assets/img/like1.png"
                        alt
                        v-if="item.is_like == false"
                        @click="commentBtn(item.id, i)"
                      />
                      <img
                        src="@/assets/img/like2.png"
                        alt
                        v-else
                        @click="commentBtn(item.id, i)"
                      />
                    </div>
                  </li>
                </ul>
                <div class="morePage" v-if="show_page">
                  <div @click="moreData">
                    <p>加载更多资讯</p>
                    <div>
                      <img src="@/assets/img/more.png" alt />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-r">
          <AboutAuthor
            :audio_serie_id="audio_serie_id"
            v-show="is_com == 1"
          ></AboutAuthor>
          <Wechart v-show="is_com == 2"></Wechart>
          <RightAdv v-if="id" :keys="id" :advId="652"></RightAdv>
        </div>
      </div>
    </div>
    <!-- 弹框 -->
    <LoginDialog
      :loginDialogs="loginDialogs"
      @child-event="getParentEvent"
    ></LoginDialog>
  </div>
</template>
<script>
import { getone, advclick } from "@/api/adv";
import Topadv from "@/components/topadv";
import AboutAuthor from "@/components/aboutAuthor";
import Wechart from "@/components/wechart";
import LoginDialog from "@/components/loginDialog";
import RightAdv from "@/components/rightadv.vue";
import DetailPagation from "@/components/detailPagation.vue";
import {
  getFreeArticleDetail,
  getArticleComment,
  getPublishComment,
  getArctileLike,
  getCollection,
  getCommentLike
} from "@/api/public";
export default {
  name: "hot_detail",
  components: {
    Wechart,
    AboutAuthor,
    LoginDialog,
    Topadv,
    RightAdv,
    DetailPagation
  },
  data() {
    return {
      is_com: 0,
      audio_serie_id: 0,
      isLoginDialogs: 0,
      loginDialogs: false,
      show_page: true,
      page: 1,
      per: 5,
      play_count: 1,
      member_btn: 1,
      title: "",
      programTitle: "",
      showall: false,
      avatar: "", // 用户头像
      infoList: {},
      commentCont: "", // 评价内容
      evaluateList: [],
      showAvatar: true,
      isSearch: false,
      PId: "",
      pTitle: "",
      keyword: "",
      loading: true
    };
  },
  methods: {
    getParentEvent(data) {
      this.loginDialogs = data;
    },
    moreData() {
      this.getCommentsList();
    },
    goAudio(id) {
      this.$router.push({
        name: "radio_detail",
        params: { id: id }
      });
    },
    aboutLaber(item) {
      this.resetSetItem("isActive", 0);
      this.$router.push({
        name: "hot_laber",
        params: {
          name: item,
          isSearch: false,
          type: "undefined"
        }
      });
    },
    audition() {
      this.$emit("getIsPlaying", this.play_count++);
    },
    all() {
      if (
        localStorage.getItem("Authorization") == "" ||
        localStorage.getItem("Authorization") == null
      ) {
        // this.isLoginDialogs++;
        this.loginDialogs = true;
      } else if (!this.infoList.is_jurisdiction) {
        this.$emit("getIsPlaying", this.play_count++);
        this.$emit("getMemberBtn", this.member_btn++);
      } else {
        this.showall = !this.showall;
      }
    },
    // 会员弹框
    memberBtn() {
      this.$emit("getIsPlaying", this.play_count++);
      this.$emit("getMemberBtn", this.member_btn++);
    },
    commentBtn(id, i) {
      if (
        localStorage.getItem("Authorization") == "" ||
        localStorage.getItem("Authorization") == null
      ) {
        // this.isLoginDialogs++;
        this.loginDialogs = true;
      } else {
        if (this.evaluateList[i].is_like) {
          this.evaluateList[i].like_times--;
        } else {
          this.evaluateList[i].like_times++;
        }
        this.evaluateList[i].is_like = !this.evaluateList[i].is_like;
        getCommentLike(id);
      }
    },
    // 收藏
    collectionBtn() {
      if (
        localStorage.getItem("Authorization") == "" ||
        localStorage.getItem("Authorization") == null
      ) {
        // this.isLoginDialogs++;
        this.loginDialogs = true;
      } else {
        var type = "";
        if (
          this.infoList.article_type == "sound" ||
          this.infoList.article_type == "voice"
        ) {
          type = "AudioArticle";
        } else {
          type = "Article";
        }
        getCollection(this.id, type).then(res => {
          this.infoList.is_favorited = !this.infoList.is_favorited;
          if (this.infoList.is_favorited == true) {
            this.infoList.favorite_times += 1;
          } else {
            this.infoList.favorite_times -= 1;
          }
        });
      }
    },
    // 文章点赞
    praiseBtn() {
      if (
        localStorage.getItem("Authorization") == "" ||
        localStorage.getItem("Authorization") == null
      ) {
        // this.isLoginDialogs++;
        this.loginDialogs = true;
      } else {
        getArctileLike(this.id).then(res => {
          this.infoList.is_like = !this.infoList.is_like;
          if (this.infoList.is_like == true) {
            this.infoList.like_times += 1;
          } else {
            this.infoList.like_times -= 1;
          }
        });
      }
    },
    // 发表评论
    publishBtn() {
      if (
        localStorage.getItem("Authorization") == "" ||
        localStorage.getItem("Authorization") == null
      ) {
        // this.isLoginDialogs++;
        this.loginDialogs = true;
      } else {
        var type = "";
        if (
          this.infoList.article_type == "sound" ||
          this.infoList.article_type == "voice"
        ) {
          type = "AudioArticle";
        } else {
          type = "Article";
        }
        var params = {
          content: this.commentCont,
          audio_columns_id: this.infoList.audio_id,
          article_type: type
        };
        getPublishComment(this.id, params).then(res => {
          this.commentCont = "";
          this.$message.success("发表成功");
        });
      }
    },
    getCommentsList() {
      var params = {
        page: this.page,
        per: this.per
      };
      getArticleComment(this.id, params).then(res => {
        this.evaluateList = this.evaluateList.concat(res.data.data);
        if (this.page >= res.data.meta.total_pages) {
          this.show_page = false;
        } else {
          this.page++;
        }
      });
    },
    //右侧广告跳转
    rightAdvClick(data, url) {
      advclick(
        data,
        "article",
        this.infoList.article_type + "[" + this.id + "]",
        this.id
      );
      window.open(url, "_blank");
    },
    //顶部广告跳转
    topAdvClick(data, url) {
      advclick(
        data,
        "article",
        this.infoList.article_type + "[" + this.id + "]",
        this.id
      );
      window.open(url, "_blank");
    }
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.id = newVal.params.id;
        this.keywords = this.id;
        this.PId = newVal.params.PId;
        this.pTitle = newVal.params.pTitle;
        this.keyword = newVal.params.keyWord;
        this.isSearch = newVal.params.isSearch;
        this.resetParams(this, ["PId", "id", "pTitle", "keyword", "isSearch"]);
        if (localStorage.getItem("Authorization") != null) {
          var userInfo = JSON.parse(localStorage.getItem("userInfo"));
          this.avatar = userInfo.avatar;
          this.showAvatar = false;
        }
        getFreeArticleDetail(this.id).then(res => {
          this.loading = false;
          this.programTitle = res.data.data.audio_title;
          this.title = res.data.data.title;
          this.infoList = res.data.data;
          this.PId = res.data.data.audio_id;
          if (this.infoList.is_jurisdiction) {
            this.showall = true;
          }
          this.audio_serie_id = this.infoList.id;
          const {
            audio_id,
            audio_title,
            id,
            title,
            article_type,
            read_time,
            display_time,
            authors,
            topics
          } = this.infoList;
          try {
            this.$ba([
              ["ptype", "detail"],
              ["pchannel", "webpc"],
              ["aaction", "pageview"],
              ["acategory", "radio"],
              ["acname", "音频"],
              ["acategory2", 'radio' + audio_id],
              ["ac2name", audio_title],
              ["aid", id],
              ["atitle", title],
              ["aauthor", authors.length && authors[0].name],
              ["atype", "radio"],
              [
                "atag",
                (topics && topics.length && topics.map(tag => tag.name)) || []
              ],
              ["aprod", "magazine"],
              ["actime", display_time],
              ["artime", read_time]
            ]);
            if (
              this.infoList.hasOwnProperty("sound") &&
              this.infoList.sound.audio_type == "AudioMagazine"
            ) {
              this.is_com = 1;
            } else {
              this.is_com = 2;
            }
            // console.log(res.data.data)
            const head = document.getElementsByTagName('head')
            const meta = document.createElement('meta')
            document.title= res.data.data.topic;
            document.querySelector('meta[name="keywords"]').setAttribute('content',res.data.data.keyword)
            document.querySelector('meta[name="description"]').setAttribute('content', res.data.data.describe)
            head[0].appendChild(meta)
          } catch (error) {
            console.log("====================================");
            console.log(error);

            console.log("====================================");
          }
        });
        this.getCommentsList();
      }
    }
  },

  mounted() {
    this.$emit("getAId", this.id);
  }
};
</script>
<style lang="scss" scoped>
.copyright {
  font-size: 14px;
  color: #999;
  text-align: center;
  line-height: 30px;
}
.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;
  .crumb {
    cursor: pointer;
  }
}
.box {
  background: #ffffff;
  padding: 30px 30px 20px 30px;
  margin-bottom: 50px;
  .article-detail {
    display: flex;
    justify-content: space-between;
    .left {
      display: flex;
      width: 100%;
      .img {
        position: relative;
        height: 176px;
        img {
          width: 176px;
          height: 176px;
          object-fit: cover;
        }
        .articleImg {
          z-index: 3;
          position: absolute;
          border-radius: 50%;
          left: 50%;
          top: 50%;
          width: 126px;
          height: 126px;
          transform: translate(-50%, -50%);
        }
      }
      .info {
        margin-left: 30px;
        width: 100%;
        .name {
          font-size: 30px;
          font-weight: bold;
          margin-top: 2px;
        }
        .data {
          margin: 14px 0;
          display: flex;
          justify-content: space-between;
          div {
            display: inline-block;
            margin-right: 16px;
            span {
              color: #999999;
              margin-right: -4px;
            }
          }
        }
        .from {
          color: #0091ff;
          margin-bottom: 26px;
          span {
            color: #999999;
          }
        }
        .btn {
          .el-button {
            color: #0091ff;
            border-color: #0091ff;
            height: 36px;
            border-radius: 18px;
            padding: 0;
            width: 90px;
            span {
              img {
                vertical-align: middle;
              }
            }
          }
          .el-button:hover,
          .el-button:focus {
            background: #ffffff;
          }
          .el-button:last-child {
            background: #0091ff;
            color: #fff;
          }
          .el-button:last-child:hover {
            background: #0091ff;
          }
        }

        .nums {
          display: flex;
          color: #999999;
          align-items: center;
          line-height: 42px;
          div {
            vertical-align: middle;
            img {
              vertical-align: middle;
              margin-right: 4px;
              cursor: pointer;
              width: 16px;
              height: 16px;
            }
            span {
              vertical-align: middle;
            }
          }
          div:last-child {
            margin-left: 24px;
          }
        }
      }
    }
    .laberList {
      color: #0091ff;
      text-align: right;
      position: relative;
      min-width: 24%;
      margin-right: 0 !important;
      .laber {
        display: inline-block;
        cursor: pointer;
        margin-left: 10px;
        margin-right: 0 !important;
      }
    }
  }
  .progranmText {
    margin-top: 30px;
    position: relative;
    margin-bottom: 30px;
    .title {
      font-size: 18px;
      padding-bottom: 10px;
      border-bottom: 1px solid #eeeeee;
      span {
        border-bottom: 4px solid #0091ff;
        padding-bottom: 6px;
      }
    }
    div {
      font-size: 18px;
      line-height: 36px;
      margin-top: 20px;
    }
    .showall {
      padding: 10px;
      height: 210px;
      overflow: hidden;
      clear: both;
      margin-top: 6px;
      >>> figcaption {
        text-align: center;
        color: #999999;
        margin-bottom: 10px;
      }
    }
    .showall.active {
      //点击了查看更多，就高度就不管了。随实际的大小变化
      height: auto;
      background: #fff;
      min-height: 150px;
      text-align: justify;
    }
    .cont-mask {
      position: absolute;
      bottom: 66px;
      width: 100%;
      height: 20px;
      z-index: 2;
      img {
        width: 100%;
        height: auto;
        object-fit: cover;
      }
    }
  }
  .imgbtn {
    bottom: -60px;
    position: absolute;
    z-index: 2;
    width: 100%;
    text-align: center;
    color: #0091ff;
    cursor: pointer;
  }
  .comment {
    border-top: 1px solid #eeeeee;
    .title {
      margin: 25px 0;
      font-size: 16px;
      font-weight: 600;
    }
    .comment-box {
      display: flex;
      .img {
        margin-right: 20px;
        width: 8%;
        img {
          width: 100%;
          object-fit: cover;
          border-radius: 50%;
          min-height: 60px;
        }
      }
      .commentInput {
        width: 100%;
        >>> .el-textarea__inner {
          border-radius: 0;
        }
        >>> .el-textarea .el-input__count {
          color: #999999;
          background: #fff;
          position: absolute;
          font-size: 14px;
          bottom: -38px;
          left: 0px;
          width: 40px;
        }
        div {
          // margin-top: 12px;
          text-align: right;
          .el-button {
            border-radius: 18px;
            width: 90px;
            height: 36px;
            padding: 0;
            background: #0091ff;
            color: #fff;
          }
        }
        div:last-child {
          margin-top: 12px;
        }
      }
    }
    .evaluate {
      li {
        display: flex;
        border-bottom: 1px solid #eeeeee;
        padding-bottom: 54px;
        margin-top: 30px;
        position: relative;
        .img {
          width: 7%;
          height: 7%;
          margin-right: 20px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 50%;
          }
        }
        .cont {
          width: 80%;
          font-size: 16px;
          .name {
            line-height: 36px;
            font-weight: 500;
          }
          .time {
            font-size: 14px;
            color: #999999;
          }
          div {
            line-height: 30px;
            margin-top: 10px;
          }
        }
        .like {
          width: 10%;
          position: absolute;
          bottom: 26px;
          right: 0;
          text-align: right;
          span {
            margin-right: 6px;
            color: #999999;
            font-size: 14px;
            vertical-align: middle;
          }
          img {
            vertical-align: middle;
          }
        }
      }
      li:last-child {
        padding-bottom: 30px;
        border-bottom: none;
        margin-bottom: 10px;
        .like {
          bottom: 0;
        }
      }
    }
  }
}
.singleDialog {
  >>> .el-dialog__header {
    display: none;
  }
  >>> .el-dialog__body {
    padding: 0;
    margin-top: 5px;
  }
  .singleList {
    .header {
      display: flex;
      justify-content: space-between;
      background: url("../../assets/img/bg_single.png") no-repeat;
      padding: 20px 20px 20px 30px;
      background-size: auto;
      .message {
        display: flex;
        .img {
          width: 70px;
          height: 70px;
          margin-right: 20px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 50%;
          }
        }
        div {
          p {
            font-size: 20px;
            color: #9a6416;
            margin-top: 6px;
          }
          p:last-child {
            font-size: 14px;
            span {
              color: #ff0000;
            }
          }
        }
      }
    }
    .dialog-body {
      padding: 6px 30px 30px 30px;
      h3 {
        color: #dfb349;
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 40px;
      }
      h4 {
        color: #dfb349;
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 40px;
        span {
          vertical-align: middle;
          display: inline-block;
        }
        img {
          vertical-align: middle;
          display: inline-block;
        }
      }
      .body-message {
        display: flex;
        align-items: center;
        .subsrcibe {
          display: contents;
          width: 100%;
          li {
            width: 30.5%;
            border: 1px solid #eeeeee;
            position: relative;
            margin-right: 30px;
            cursor: pointer;
            .subsrcibe-box {
              width: 100%;
              text-align: center;
              padding: 10px;
              font-size: 16px;
              .img {
                img {
                  position: absolute;
                  left: 10px;
                  top: 10px;
                }
              }
              .limited {
                position: absolute;
                background: #ff0000;
                padding: 5px 12px;
                border-radius: 0 10px 0 10px;
                right: -2px;
                top: -17px;
                color: #fff;
                font-size: 14px;
              }
              p {
                line-height: 36px;
                margin-top: 20px;
              }
              .message {
                color: #dfb349;
                font-size: 18px;
                margin-bottom: 10px;
                span {
                  font-size: 30px;
                  font-weight: 600;
                  margin-left: -9px;
                }
              }
            }
          }
          .showIcon {
            border: 2px solid #dfb349;
            background: #fcf7e6;
          }
        }
        .other {
          display: flex;
          justify-content: space-between;
          li {
            margin-right: 0;
          }
        }
        .buy-tips {
          font-size: 14px;
          ul {
            li {
              margin-bottom: 20px;
            }
          }
          p {
            padding-bottom: 10px;
            text-decoration: underline;
            color: #0091ff;
            cursor: pointer;
          }
        }
      }
      .pay-method {
        border: 1px solid #eeeeee;
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        .method {
          display: flex;
          flex-direction: column;
          margin-right: 40px;
          .el-button {
            border: 1px solid #eeeeee;
            background: #f5f5f5;
            text-align: center;
            line-height: 100px;
            border: none;
            margin-left: 0;
            border-radius: 0;
            font-size: 16px;
            padding: 0 40px;
            .icon {
              img {
                vertical-align: middle;
                margin-right: 4px;
              }
            }
          }
          .selectBtn {
            background: #fff;
            border-right: 0;
          }
          .isActive {
            background: #fff;
            border-right: 0;
          }
          >>> .el-button:hover,
          .el-button:active,
          .el-button:focus {
            color: #333 !important;
          }
        }
        .pay-message {
          display: flex;
          align-items: center;
          margin-right: 16px;
          .wechart {
            text-align: center;
            color: #999999;
            margin-right: 30px;
            .img {
              // max-width: 130px;
              padding: 10px;
              border: 1px solid #eeeeee;
              margin-bottom: 6px;
              img {
                width: 100%;
                object-fit: cover;
              }
              >>> #canvas {
                width: 136px;
                height: 136px;
              }
            }
          }
          .pay {
            font-size: 16px;
            p {
              line-height: 38px;
              span {
                color: #dfb349;
                font-size: 30px;
                font-weight: bold;
              }
            }
            p:last-child {
              color: #999999;
            }
          }
        }
      }
    }
  }
}

//新增广告样式
.topBanner {
  position: relative;
  margin: 30px 0;
  display: block;
  // border: 1px solid;
  background: #fff;
  height: 90px;
  span {
    position: absolute;
    left: 0;
    bottom: 0;
    font-size: 12px;
    color: #fff;
    background: #33333380;
    line-height: 20px;
    padding: 0 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/radio/hot-detail.vue